import './Settings.scss';

import { useEffect } from 'react';

import { PageIntro } from '@components/PageIntro/PageIntro';
import { MYOME_SUPPORT_EMAIL } from '@constants/constants';
import ContentContainer from '@layouts/container/ContentContainer';
import PageContainer from '@layouts/container/PageContainer';
import { recordGoogleAnalyticsSend } from '@utils/helpers';

import PatientInformation from './components/PatientInformation/PatientInformation';
import { PrefAndConsents } from './components/PrefAndConsents/PrefAndConsents';

const Settings = () => {
  useEffect(() => {
    recordGoogleAnalyticsSend('pageview', '/account', 'Landing on My Accounts Page');
  }, []);

  return (
    <PageContainer>
      <ContentContainer containerClass='bg-body py-4' contentClass='settings-header'>
        <PageIntro
          title='My Account'
          description={
            <>
              If any of this information is inaccurate, please contact us at{' '}
              <a href={`mailto:${MYOME_SUPPORT_EMAIL}`} className='fw-medium'>
                {MYOME_SUPPORT_EMAIL}
              </a>
              .
            </>
          }
        />
      </ContentContainer>
      <ContentContainer containerClass='py-4'>
        <div className='d-flex flex-column gap-4'>
          <h4 className='text-primary pb-2 border-bottom fw-semibold mb-0'>Patient Information</h4>
          <PatientInformation />

          <h4 className='text-primary pb-2 border-bottom fw-semibold mb-0'>Preferences and Consents</h4>
          <PrefAndConsents />
        </div>
      </ContentContainer>
    </PageContainer>
  );
};

export default Settings;
